// src/utils/devtoolsDetector.js

export const detectDevTools = () => {
  const checkDevTools = () => {
    const start = performance.now();
    debugger; // This line triggers a breakpoint if DevTools is open
    const end = performance.now();
    
    // If DevTools is open, the debugger statement causes a delay
    if (end - start > 100) {
      return true;
    }
    
    // Check for DevTools by element dimension
    const element = new Image();
    Object.defineProperty(element, 'id', {
      get: function() {
        return true;
      }
    });
    
    return false;
  };
  
  const clearAppContent = () => {
    // Clear the entire React app
    const root = document.getElementById('root');
    if (root) {
      root.innerHTML = `
        <div style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100vh;
          font-family: Arial, sans-serif;
          text-align: center;
          padding: 20px;
          background: #f5f5f5;
        ">
          <h1 style="color: #d32f2f;">⚠️ Access Denied</h1>
          <p>Developer Tools are not allowed to be used in this application.</p>
          <p>Please close Developer Tools and refresh the page to continue.</p>
          <button onclick="location.reload()" style="
            margin-top: 20px;
            padding: 10px 20px;
            background: #1976d2;
            color: white;
            border: none;
            border-radius: 5px;
            cursor: pointer;
          ">Refresh Page</button>
        </div>
      `;
    }
  };
  
  // Check periodically
  setInterval(() => {
    if (checkDevTools()) {
      clearAppContent();
    }
  }, 1000);
  
  // Detect F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U, Ctrl+S
  window.addEventListener('keydown', (e) => {
    if (
      e.key === 'F12' ||
      (e.ctrlKey && e.shiftKey && e.key === 'I') ||
      (e.ctrlKey && e.shiftKey && e.key === 'J') ||
      (e.ctrlKey && e.key === 'U') ||
      (e.ctrlKey && e.key === 's') ||
      (e.ctrlKey && e.shiftKey && e.key === 'C')
    ) {
      e.preventDefault();
      clearAppContent();
      return false;
    }
  });
  
  // Detect right-click
  window.addEventListener('contextmenu', (e) => {
    e.preventDefault();
    return false;
  });
  
  // Check if DevTools is open on load
  if (checkDevTools()) {
    clearAppContent();
  }
};